module.exports = __webpack_public_path__ + "static/media/cpu.1660ebb4.svg";